import { render, staticRenderFns } from "./NumberCards.vue?vue&type=template&id=e7624100&"
import script from "./NumberCards.vue?vue&type=script&lang=js&"
export * from "./NumberCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports